import type { ZonePopulation } from "@/features/deployment-dashboard/types";

/**
 * Returns the occupancy percentage for a zone, clamped to a minimum of 0.
 * Returns 0 when capacity is 0 to avoid division by zero.
 */
export function getZoneOccupancyPercent(zone: ZonePopulation): number {
  if (zone.capacity === 0) return 0;
  return Math.round((zone.current / zone.capacity) * 100);
}

/**
 * Formats an integer count with locale-aware thousand separators.
 * Always uses "en-GB" locale for consistent rendering across environments.
 * e.g. 59797 -> "59,797"
 */
export function formatCount(value: number): string {
  return new Intl.NumberFormat("en-GB").format(value);
}
